/**
 * Small note/music helpers. Pure functions — cheap to test, easy to inline
 * at call sites so we don't leak this stuff across too many files.
 */

/** MIDI note 69 = A4 = 440 Hz. */
export const A4_MIDI = 69;
export const A4_HZ = 440;

export const NOTE_NAMES = [
  'C',
  'C#',
  'D',
  'D#',
  'E',
  'F',
  'F#',
  'G',
  'G#',
  'A',
  'A#',
  'B',
] as const;

export function midiToHz(midi: number): number {
  return A4_HZ * Math.pow(2, (midi - A4_MIDI) / 12);
}

/**
 * "C4", "F#5" etc. MIDI 60 = C4 in the common convention; some DAWs call it
 * C3. We use the C4 = 60 convention because it matches most modern tooling.
 */
export function midiToName(midi: number): string {
  const n = Math.round(midi);
  const noteIdx = ((n % 12) + 12) % 12;
  const octave = Math.floor(n / 12) - 1;
  return `${NOTE_NAMES[noteIdx]}${octave}`;
}

/** True for the black keys (C#, D#, F#, G#, A#). */
export function isBlackKey(midi: number): boolean {
  const n = ((midi % 12) + 12) % 12;
  return n === 1 || n === 3 || n === 6 || n === 8 || n === 10;
}
